import I18N from './interface';

const en: I18N = {
  // Side Menu
  MyWorkItems: 'My Work Items',
  LoadManagement: 'Load Management',
  Communications: 'Communications',
  Compliance: 'Compliance',
  Contracts: 'Contracts',
  Invoices: 'Invoices',
  ScoreCard: 'Score Card',
  AllLoads: 'All Loads',
  LoadBoard: 'Load Board',
  LoadsSummary: 'Loads Summary',
  Search: 'Search...',
  MultipleRoles: 'Multiple Roles',
  CustomerService: 'Customer Service',
  Planner: 'Planner',
  Engineer: 'Engineer',
  ViewProfile: 'View Profile',
  MyProfile: 'My Profile',
  Themes: 'Themes',
  Logout: 'Logout',
  TemplateCustomize: 'Template Customize',
  Customizeandpreview: 'Customize and preview in real time',
  ThemeStyle: 'Theme Style',
  Light: 'Light',
  Dark: 'Dark',
  DarkGreen: 'Dark Green',
  TurkishAqua: 'Turkish Aqua',
  Blue: 'Blue',
  SoothingBreeze: 'Soothing Breeze',
  Languages: 'Languages',
  UnitedStates: 'United States',
  Spanish: 'Spanish',
  German: 'German',
  French: 'French',
  Brazil: 'Brazil',
  QuickLinks: 'Quick Links',
  FailedToFetchTenantDetails: 'Failed to fetch tenant details',
  FailedToFetchTenderDetails: 'Failed to fetch tender details',
  PageNotFound: 'Page Not Found !',
  Exceptions: 'Exceptions',

  // My work items
  View: 'View',
  Tenders: 'Tenders',
  TotalTenders: 'Total Tenders',
  PendingForAction: 'Pending for Action',
  Accepted: 'Accepted',
  Rejected: 'Rejected',

  UpdateCheckCalls: 'Update Check Calls',
  Total: 'Total',
  Pickups: 'Pickups',
  Deliveries: 'Deliveries',

  IntegrationFailure: 'Integration Failure',
  MissingRates: 'Missing Rates',
  InvoiceDiscrepancy: 'Invoice Discrepancy',
  DamagesAndClaims: 'Damages & Claims',
  TrackingMap: 'Tracking Map',

  // all loads
  TenderId: 'Tender ID',
  Status: 'Status',
  Source: 'Source',
  Mode: 'Mode',
  Origin: 'Origin',
  Destination: 'Destination',
  PUDateAndTime: 'PU Date & Time',
  DeliveryDateAndTime: 'Delivery Date & Time',

  // Transport Status Labels
  Unknown: 'Unknown',
  Created: 'Created',
  Tendered: 'Tendered',
  PrePickup: 'Pre-Pickup',
  AtStop: 'At Stop',
  InTransit: 'In Transit',
  Completed: 'Completed',
  Closed: 'Closed',
  Cancelled: 'Cancelled',
  PostedForBid: 'Posted For Bid',

  DateValidationMessage:
    "Please ensure the 'From Date' is earlier than the 'To Date'.",
  From: 'From',
  To: 'To',
  Clear: 'Clear',
  Apply: 'Apply',

  Details: 'Details',
  UploadAndUpdate: 'Upload & Update',

  // load board
  Actions: 'Actions',
  TransportID: 'Transport ID',
  ScheduledPuDateAndTime: 'Scheduled PU Date & Time',
  TrailerType: 'Trailer Type',
  TransitDays: 'Transit Days',
  TargetRate: 'Target Rate',
  PostedBy: 'Posted By',
  Comments: 'Comments',
  PostedDateAndTime: 'Posted Date & Time',
  PickupCloseDate: 'Pickup Close Date',

  // Common
  Add: 'Add',
  Save: 'Save',
  Cancel: 'Cancel',
  NoDataToShow: 'No Data to Show',
  ChooseFile: 'Choose File',
  NoFileChosen: 'No File Chosen',
  FileSizeInfo: 'PDF and JPEG up to 10MB',

  // Navigation
  MyWork: 'My Work',

  // User
  Admin: 'Admin',

  // Headers
  ContractInformation: 'Contract Information',
  InsuranceInformation: 'Insurance Information',
  LicensingInformation: 'Licensing Information',
  EmissionsCompliance: 'Emissions Compliance',

  // Insurance Form
  InsuranceType: 'Insurance Type',
  AdditionallyInsured: 'Additionally Insured',
  InsuranceCompanyName: 'Insurance Company Name',
  PolicyNumber: 'Policy Number',
  InsuranceContactName: 'Insurance Contact Name',
  InsuranceContactPhone: 'Insurance Contact Phone',
  PolicyAmount: 'Policy Amount',
  RenewalReminderInDays: 'Renewal Reminder (In Days)',
  EffectiveDate: 'Effective Date',
  ExpirationDate: 'Expiration Date',
  UploadDocumentPicture: 'Upload Document / Picture',

  // Licensing Form
  OperatingAuthorityAndLicensing: 'Operating Authority and Licensing',
  LicenseCertificateType: 'License / Certificate Type',
  LicenseCertificateName: 'License / Certificate Name',
  LicenseCertificateNo: 'License / Certificate No',

  // Emissions Form
  CarbonEmissionRating: 'Carbon Emission Rating',
  SafetyRating: 'Safety Rating',
  MinorityCarrier: 'Minority Carrier',
  EnvironmentalCertification: 'Environmental Certification',
  Yes: 'Yes',
  No: 'No',

  // Contract Form
  ContractName: 'Contract Name',
  Description: 'Description',
  Scac: 'SCAC',
  ReferenceNumber: 'Reference Number',
  Currency: 'Currency',
  RenewalReminder: 'Renewal Reminder',
  UploadContract: 'Upload Contract',
  Audit: 'Audit',
  NoDocumentsToShow: 'No Documents to show',

  // Table Headers
  Documents: 'Documents',

  // Placeholders
  EnterName: 'Enter Name',
  EnterContractName: 'Enter contract name',
  EnterContractDescription: 'Enter contract description',
  EnterScac: 'Enter SCAC',
  EnterReferenceNumber: 'Enter reference number',
  EnterPolicyNumber: 'e.g 1234567954',
  EnterAuthority: 'Enter Authority',
  EnterType: 'Enter Type',
  EnterNumber: 'Enter Number',
  SelectDate: 'MM/DD/YYYY',
  Select: 'Select',

  // Import Actions
  Import: 'Import',
  ImportFromPdf: 'Import from PDF',
  ImportFromExcel: 'Import from Excel',
  ImportFromCsv: 'Import from CSV',

  // Create Actions
  CreateNewContract: 'Create New Contract',

  // Search
  SearchByContractName: 'Search by Contract Name',

  // Score Card
  CarrierRating: 'Carrier Rating',
  CalculationInfo: 'Calculation Info',
  KPI: 'KPI',
  WeightedAverage: 'Weighted Average',
  WeightedScore: 'Weighted Score',
  Performance: 'Performance',
  Score: 'Score',

  UpdateDetails: 'Update Details',
  ProNumber: 'Pro Number',
  TelephoneNo: 'Telephone No',
  SealNumber: 'Seal Number',
  TrailerOrContainerNo: 'Trailer / Container No',
  CabOrPowerNo: 'Cab / Power No',
  CustomsSealNumber: 'Customs Seal Number',

  UploadDocuments: 'Upload Documents',
  ReferenceType: 'Reference Type',
  ReferenceNo: 'Reference No',
  UploadDocumentOrPicture: 'Upload Document / Picture',
  PDFandJPEGupto10MB: 'PDF and JPEG up to 10MB',

  UploadPOD: 'Upload POD',
  ShipmentNo: 'Shipment No',
  Name: 'Name',
  DateAndTime: 'Date & Time',
  UploadDocument: 'Upload Document',

  TransportationMode: 'Transportation Mode',
  EquipmentType: 'Equipment Type',
  SealNo: 'Seal No',
  CustomsSealNo: 'Customs Seal No',
  ServiceType: 'Service Type',
  ServiceLevel: 'Service Level',

  ArrivalBegin: 'Arrival Begin',
  ArrivalEnd: 'Arrival End',
  CutTime: 'Cut Time',
  DepartureBegin: 'Departure Begin',
  DepartureEnd: 'Departure End',
  LoadType: 'Load Type',
  DriverName: 'Driver Name',
  // Pending Tenders Grid
  OriginStreetAddress: 'Origin Street Address',
  OriginCity: 'Origin City',
  OriginState: 'Origin State',
  OriginPostalCode: 'Origin Postal Code',
  DestinationStreetAddress: 'Destination Street Address',
  DestinationCity: 'Destination City',
  DestinationState: 'Destination State',
  DestinationPostalCode: 'Destination Postal Code',
  NoOfShipments: 'No of Shipments',
  Quantity: 'Quantity',
  Weight: 'Weight',
  PickupDateTime: 'Pickup Date & Time',
  DeliveryDateTime: 'Delivery Date & Time',
  TenderDate: 'Tender Date',
  Comment: 'Comment',
  WaitingForPickup: 'Waiting for Pickup',

  //invoice
  InvoiceNumber: 'Invoice Number',
  Enter: 'Enter',
  InvoiceDate: 'Invoice Date',
  DueDate: 'Due Date',
  DocumentType: 'Document Type',
  SaveAsDraft: 'Save As Draft',
  Send: 'Send',
  TrailerNumber: 'Trailer Number',
  LoadNumber: 'Load Number',
  TotalHUs: "Total HU's",
  TotalWeight: 'Total Weight',
  BaseRate: 'Base Rate',
  Accessorials: 'Accessorials',
  AccessorialRate: 'Accessorial Rate',
  DeliveryFromDate: 'Delivery From Date',
  DeliveryToDate: 'Delivery To Date',
  InvoiceSentDate: 'Invoice Sent Date',
  NoOfLoads: 'No of Loads',
  UploadInvoice: 'Upload Invoice',
  InvoiceHistory: 'Invoice History',
  ShowInvoices: 'Show Invoices',
  Drafts: 'Drafts',

  // Invoice columns
  InvoiceNo: 'Invoice No',

  // Transport View
  TenderDetails: 'Tender Details',
  TenderCutOffTime: 'Tender Cut-Off Time',
  CheckCallRequirements: 'Check Call Requirements',
  Interval: 'Interval',
  CarrierDetails: 'Carrier Details',
  RateInformation: 'Rate Information',
  StopDetails: 'Stop Details',
  AccountInformation: 'Account Information',
  MailInvoiceTo: 'Mail Invoice To',
  ForAccountOf: 'For Account Of',
  Accept: 'Accept',
  Reject: 'Reject',
  ViewBOL: 'View BOL',
  ViewPOD: 'View POD',
  Download: 'Download',
  Print: 'Print',
  New: 'New',
  Stop: 'Stop',
  Pickup: 'Pickup',
  Delivery: 'Delivery',
  DeliveryPickup: 'Delivery / Pick Up',
  ContactInfo: 'Contact Info',
  ShipmentDetails: 'Shipment Details',
  ShipID: 'Ship ID',
  TotalQuantityWeight: 'Total Quantity / Weight',
  HandlingUnits: 'Handling Units',
  Pallets: 'Pallets',
  Boxes: 'Boxes',
  Dimensions: 'Dimensions',
  Notes: 'Notes',

  TotalLoads: 'Total Loads',
  UpcomingLoads: 'Upcoming Loads',
  Delivered: 'Delivered',
  FTLLoads: 'FTL Loads',
  LTLLoads: 'LTL Loads',
  AllInTransitLoads: 'All In Transit Loads',
  AllAcceptedLoadStatus: 'All Accepted Load Status',
  Upcoming: 'Upcoming',
  OnTimeDelivery: 'On Time Delivery',
  DelayedDeliveries: 'Delayed Deliveries',
  OnTimePickup: 'On Time Pickup',
  DelayInTransit: 'Delay In Transit',
  RejectedLoads: 'Rejected Loads',

  LoadsTender: 'Loads Tender',
  InvoiceAccuracy: 'Invoice Accuracy',
  CheckCallAccuracy: 'Check Call Accuracy',
  DamageFreeShipments: 'Damage Free Shipments',
  Professionalism: 'Professionalism',

  ShipmentEntry: 'Shipment Entry',
  HUNo: 'HU No',
  NoOfHUs: 'No Of HU s',
  HUWeight: 'HU Weight',
  Hazmat: 'Hazmat',
  Accessorial: 'Accessorial',
  Border: 'Border',
  ShipmentManifest: 'Shipment Manifest',
  Accessories: 'Accessories',
  TotalQuantity: 'Total Quantity',
  ReferenceAndDocuments: 'References and Documents',
  CarrierInvoiceTo: 'Carrier Invoice To',

  ModesAndEquipment: 'Modes and Equipment',
  PickupWindow: 'Pickup Window',
  DeliveryWindow: 'Delivery Window',
  CostDetails: 'Cost Details',
  RateOnTender: 'Rate on Tender',
  FreightCost: 'Freight Cost',
  FuelCost: 'Fuel Cost',
  TotalCost: 'Total Cost',
  TrackingMethod: 'Tracking Method',
  CheckCalls: 'Check Calls',
  SystemGeneratedDoc: 'System Generated Doc',
  PrintDoc: 'Print Doc',
  TenderInstructions: 'Tender Instructions',

  Sender: 'Sender',
  FileId: 'File ID',
  FileName: 'File Name',
  TransType: 'Transaction Type',
  Receiver: 'Receiver',
  FileType: 'File Type',
  CreatedDateTime: 'Created Date & Time',
  FailureReason: 'Failure Reason',
  Failed: 'Failed',
  InProgress: 'In Progress',
  CarrierPro: 'Carrier Pro',
  LastKnownLocation: 'Last Known Location',
  DestETA: 'Destination ETA',
  // settings
  Settings: 'Settings',
  CarrierProfile: 'Carrier Profile',
  BusinessHours: 'Business Hours',
  Contacts: 'Contacts',
  GeoFence: 'Geo-Fence',
  Equipment: 'Equipment',
  CoverageRegionPreferences: 'Coverage Region Preferences',
  Tracking: 'Tracking',
  PreAssignedReferences: 'Pre-Assigned References',
  BusinessHoursCreatedSuccessfully: 'Business Hours Created Successfully',
  PleaseProvideValidOpenAndCloseTimesForCustomWorkingHours:
    'Please Provide Valid Open and Close Times for Custom Working Hours',
  PleaseProvideValidTimeIntervalsForSaturdayAndSunday:
    'Please Provide Valid Time Intervals for Saturday and Sunday',
  Pleaseprovidevalidopenandclosetimesforcustomworkinghours:
    'Please provide valid open and close times for custom working hours',
  Businesshoursupdatedsuccessfully: 'Business hours updated successfully',
  Edit: 'Edit',
  CarrierBasicInfo: 'Carrier Basic Info',
  SCAC: 'SCAC',
  MC: 'MC#',
  DOTICC: 'DOT/ICC#',
  FederalTaxID: 'Federal Tax ID',
  CAATCode: 'CAAT Code',
  SVII: 'SVI#',
  CBSA: 'CBSA',
  ModesSupported: 'Modes Supported',
  ModesSupportedItems: ['Air', 'Ground', 'Ocean'],
  EmergencyContactInfo: 'Emergency Contact Info',
  EmergencyContactName: 'Emergency Contact Name',
  EmergencyContactPhone: 'Emergency Contact Phone',
  EmergencyContactEmail: 'Emergency Contact Email',
  PhonePlaceholder: '+1 (000) 000-0000',
  EmailPlaceholder: 'e.g. Location@example.com',
  HazmatAuthorized: 'Hazmat Authorized',

  LocationInformation: 'Location Information',
  LocationEmail: 'Location Email',
  WebsiteURL: 'Website URL',
  BranchCode: 'Branch Code',
  Country: 'Country',
  TimeZone: 'Time Zone',
  EnterWebsiteURL: 'Enter Website URL',
  EnterBranchCode: 'Enter Branch Code',

  LTL: 'LTL',
  FTL: 'FTL',
  Consol: 'Consol',
  Active: 'Active',
  Inactive: 'Inactive',
  CreateNewContact: 'Create New Contact',
  CreateNewEquipment: 'Create New Equipment',
  NoOfTractorsPowerUnits: 'No Of Tractors / Power Units',
  NoOfUnits: 'No Of Units',
  NoOfDriverSolos: 'No Of Driver Solos',
  MaxWeightForCarrier: 'Max Weight For Carrier',
  MaxPalletCountForCarrier: 'Max Pallet Count For Carrier',
  MaxWeightByET: 'Max Weight by ET',
  PleaseFillInAllRequiredFieldsBeforeSaving:
    'Please Fill In All Required Fields Before Saving',
  FailedToUpdateEquipmentType: 'Failed To Update Equipment Type',
  SearchNoDot: 'Search',
  CreateNewRegion: 'Create New Region',
  SearchByNameOrId: 'Search by Name or ID',

  TrackingMethodPriority: 'Tracking Method Priority',
  TrackingReferenceType: 'Tracking Reference Type',
  CheckCallInterval: 'Check Call Interval',
  FailedToCreateTracking: 'Failed to create tracking',
  PrimaryTrackingMethod: 'Primary Tracking Method',
  SecondaryTrackingMethod: 'Secondary Tracking Method',
  TertiaryTrackingMethod: 'Tertiary Tracking Method',
  Update: 'Update',

  ProNumberFrom: 'Pro Number From',
  ProNumberTo: 'Pro Number To',
  CustomTransportNoFrom: 'Custom Transport No From',
  CustomTransportNoTo: 'Custom Transport No To',
  InvoiceNumberFrom: 'Invoice Number From',
  InvoiceNumberTo: 'Invoice Number To',

  // Header Labels
  PartnerInvoice: 'Partner Invoice#',
  PartnerReference: 'Partner Reference#',
  InvoiceDueDate: 'Invoice Due Date',
  PoDate: 'PO Date',
  PoNumber: 'PO Number',
  SenderPartner: 'Sender Partner',
  SenderIsaId: 'Sender ISA ID',
  ReceiverPartner: 'Receiver Partner',
  ReceiverIsaId: 'Receiver ISA ID',
  CreatedByPartner: 'Created By Partner',
  CreatedDate: 'Created Date',

  // Payment Terms Labels
  Type: 'Type',
  BasicCode: 'Basic Code',
  DiscPercentage: 'Disc %',
  DiscDueDays: 'Disc Due Days',
  NetDueDate: 'Net Due Date',
  NetDueDays: 'Net Due Days',
  ShippedDate: 'Shipped Date',

  // Contact Labels
  ContactTypeCode: 'Contact Type Code',
  BasisCode: 'Basis Code',

  // Notes Labels
  NotesInfo: 'Notes Info',

  // Status Labels
  Received: 'Received',
  Processed: 'Processed',
  Error: 'Error',
  Pending: 'Pending',

  // Processing Log Labels
  Id: 'ID',
  LogType: 'Log Type',
  LogDetails: 'Log Details',
  CreatedBy: 'Created By',

  // Raw Data Labels
  RawDataDetails: 'Raw Data Details',
  Json: 'JSON',
  Xml: 'XML',
  Edi: 'EDI',

  // Missing Data Labels
  SummaryOfMissingData: 'Summary of Missing Data',

  // Action Labels
  ReProcess: 'Re-Process',
  ViewRawData: 'View Raw Data',
  Export: 'Export',
  Header: 'Header',

  AddressInformation: 'Address Information',
  CompanyName: 'Company Name',
  AddressLine: 'Address Line',
  City: 'City',
  State: 'State',
  Zip: 'Zip',
  Latitude: 'Latitude',
  Longitude: 'Longitude',
  EnterCompanyName: 'Enter Company Name',
  EnterAddress: 'Enter Address',
  EnterCity: 'Enter City',
  EnterState: 'Enter State',
  EnterZip: 'e.g. 75024',
  EnterLatitude: 'Enter Latitude Value',
  EnterLongitude: 'Enter Longitude Value',
  PersonalInformation: 'Personal Information',
  FirstName: 'First Name',
  EnterFirstName: 'Enter First Name',
  MiddleName: 'Middle Name',
  EnterMiddleName: 'Enter Middle Name',
  LastName: 'Last Name',
  EnterLastName: 'Enter Last Name',
  Alias: 'Alias',
  NickName: 'Nick Name',
  EnterNickName: 'Enter Nick Name',
  LocationName: 'Location Name',
  Title: 'Title',
  EnterTitle: 'Enter Title',
  Department: 'Department',
  Email: 'Email',

  WorkingHours: 'Working Hours',
  Custom: 'Custom',
  StartTime: 'Start Time',
  EndTime: 'End Time',
  SelectWorkingDays: 'Select Working Days',
  DaysSelected: 'Days Selcted',
  ShippingHours: 'Shipping Hours',
  ReceivingHours: 'Receiving Hours',
  SameAsBusinessHours: 'Same as Business Hours',
  Monday: 'Monday',
  Tuesday: 'Tuesday',
  Wednesday: 'Wednesday',
  Thursday: 'Thursday',
  Friday: 'Friday',
  Saturday: 'Saturday',
  Sunday: 'Sunday',
  DayOff: 'Day Off',
  FailedToCreateBusinessHours: 'Failed To Create Business Hours',
  FailedToUpdateBusinessHours: 'Failed To Update Business Hours',
  FailedToFetchingBusinessHours: 'Failed To Fetching Business Hours',
  MonFri: 'Mon - Fri',
  Open24By7: 'Open24/7',
  GeoFenceName: 'Geo Fence Name',
  EnterGeoFenceName: 'Enter Geo Fence Name',
  CheckCall: 'Check Call',
  OutlineColor: 'Outline Color',
  PostalCode: 'Postal Code',
  DateTime: 'Date & Time',
  ReasonCode: 'Reason Code',
  PlaceholderDateTime: 'MM/DD/YYYY | HH:MM',
  TrackingUpdates: 'Tracking Updates',
  PrePickupCheckCallTitle: 'Pre-Pickup Check Call Details',
  ScheduledArrivalWindow: 'Scheduled Arrival Window',
  ScheduledArrivalDate: 'Scheduled Arrival Date',
  ContactEmail: 'Contact Email',
  ContactPhone: 'Contact Phone',
  PrimaryContact: 'Primary Contact',
  Address: 'Address',
  StopInformation: 'Stop Information',

  RegionName: 'Region Name',
  US: 'U.S.',
  Canada: 'Canada',
  Mexico: 'Mexico',
  CountrySelectionMandatory: '*Country selection is mandatory to create Area',
  Include: 'Include',
  Exclude: 'Exclude',
  IncludedInArea: 'Included in Area',
  ExcludedFromArea: 'Excluded from Area',
  NoDataToView: 'No Data to view',
  SatSunWillRemainClosed: 'Sat & Sun will remain closed',
  ExceptionReason: 'Exception Reason',
  Miles: 'Miles',
  ContractFreightUSD: 'Contract Freight (USD)',
  FreightOnInvoiceUSD: 'Freight on Invoice (USD)',
  ContractFuelUSD: 'Contract Fuel (USD)',
  FuelOnInvoiceUSD: 'Fuel on Invoice (USD)',
  ContractAccessorialsUSD: 'Contract Accessorials (USD)',
  AccessorialsOnInvoiceUSD: 'Accessorials on Invoice (USD)',
  TotalInvoiceAmount: 'Total Invoice Amount',
  TenderID: 'Tender ID',
  PendingTenders: 'Pending Tenders',
  OperatingAuthority: 'Operating Authority',
  LicenseType: 'License Type',
  LicenseName: 'License Name',
  LicenseNumber: 'License Number',
  EquipmentName: 'Equipment Name',
  GrossWeight: 'Gross Weight',
  NoOfDriverTeams: 'No Of Driver Teams',
  Signature: 'Signature',
  AcceptSign: 'Accept & Sign',
  DrawSignature: 'Draw signature with mouse or touch',
  InTransitCheckCallDetails: 'In Transit Check Call Details',
  ClickToSign: 'Click to sign',
  Draw: 'Draw',
  Upload: 'Upload',
  ContractNumber: 'Contract Number',
  OrgInfo: 'Org Info',
  CountryInRegion: 'Country in Region',
  StateInRegion: 'State in Region',
  CityInRegion: 'City in Region',
  PostalCodeInRegion: 'Postal Code in Region',
  ExcludeFromRegion: 'Exclude from Region',
  Region: 'Region',
  FindOnMap: 'Find on Map',
  TenderInstructionMessage: 'Please avoid placing the shipment upside down.',
  Event: 'Event',
  User: 'User',
  EventType: 'Event Type',
  Rates: 'Rates',
  TotalActiveTransports: 'Total Active Transports',
  ScanQRCodeToFillContactInfo: 'Scan QR code to fill contact info',
  CreateNewGeoFence: 'Create New Geo-Fence',
  ExistingGeoFences: 'Existing Geo-Fences',
  SearchByTransportNo: 'Search by Transport No',
  ListView: 'List View',
  TrailerContainerNo: 'Trailer / Container No',
  CabPowerNo: 'Cab / Power No',
  Unfreeze: 'Unfreeze',
  FreezeUpdate: 'Freeze Update',
  UnfreezeDetails: 'Unfreeze Details',
  FreezeUpdateDetails: 'Freeze Update Details',
  FreezeStartDateTime: 'Freeze Start Date & Time',
  FreezeEndDateTime: 'Freeze End Date & Time',
  Reason: 'Reason',
  Close: 'Close',
  ViewOnMap: 'View on Map',
  ETA: 'ETA',
  ArrivalDateTime: 'Arrival Date / Time',
  CheckCallUpdate: 'Check Call Update',
  ActiveInvoices: 'Active Invoices',
  QuoteId: 'Quote ID',
  BidResponses: 'Bid Responses',
  BidSubmittedDateAndTime: 'Bid Submitted Date & Time',
  BidComments: 'Bid Comments',
  BidSubmittedSuccessfully: 'Bid submitted successfully',
  CounterOfferSubmittedSuccessfully: 'Counter offer submitted successfully',
  EnterValidCounterOfferAmount: 'Please enter a valid counter offer amount',
  BidDeclinedSuccessfully: 'Bid declined successfully',
  FailedToGetEquipmentTypes: 'Failed To Get Equipment Types',
  FailedToGetEquipments: 'Failed To Get Equipments',
  ErrorFetchingContractId: 'Error fetching contract by ID:',
  FailedFetchContract: 'Failed to fetch contract details',
  DocumentUploadSuccess: 'Document uploaded successfully',
  DocumentUploadError: 'Document upload error:',
  NotFound: 'Not Found',
  ContractCreatedSuccess: 'Contract created successfully',
  Ok: 'OK',
  DocumentDeletedSuccess: 'Document deleted successfully',
  Contact: 'Contact',
  All: 'All',
  Influencer: 'Influencer',
  SearchByLocation: 'Search by Location',
  DisplayId: 'Display ID',
  DisplayName: 'Display Name',
  ExpediteService: 'Expedite Service',
  EnterDisplayId: 'Enter Display ID',
  EnterDisplayName: 'Enter Display Name',
  Approve: 'Approve',
  ApprovalNotes: 'Approval Notes',
  RejectionNotes: 'Rejection Notes',
  CounterOffer: 'Counter Offer',
  CounterOfferAmount: 'Counter Offer Amount (USD)',
  Placeholderamount: '$0.00',
  Submit: 'Submit',
  WriteHere: 'Write here...',
  Decline: 'Decline',
  AcceptTender: 'Accept Tender',
  DeclineTender: 'Decline Tender',
  AreYouSureYouWantToAcceptThisTender:
    'Are you sure you want to accept this tender?',
  AreYouSureYouWantToDeclineThisTender:
    'Are you sure you want to decline this tender?',
  NoCancel: 'No, Cancel',
  YesProceed: 'Yes, Proceed',
  Integration: 'Integration',
  APIInformationForSetUp: 'API Information for Setup',
  EdiInformationForSetUp: 'EDI Information for Setup',
  IntegrationPointsWithOtherSystemsForDataExchange:
    'Integration Points with Other Systems for Data Exchange',
  ConfigurationForEDIorInvoicing: 'Configuration for EDI or Invoicing',
  ConfigurationForAPIorInvoicing: 'Configuration for API or Invoicing',
  ConfigurationForDataExchangeOrInvoicing:
    'Configuration for Data Exchange or Invoicing',
  Invoicing: 'Invoicing',
  TenderSettings: 'Tender Settings',
  TenderMethod: 'Tender Method',
  TenderResponsiveTime: 'Tender Responsive Time',
  TenderEmail: 'Tender Email',
  TenderTelephoneNo: 'Tender Telephone No',
  DocumentManagement: 'Document Management',
  KPIIntegration: 'KPI Integration',
  Notification: 'Notification',
  AdvanceTenderNotificationInDays: 'Advance Tender Notification In Days',
  TenderContactEmail: 'Tender Contact Email',
  TenderContactPhone: 'Tender Contact Phone',
  SendTenderWithoutRate: 'Send Tender Without Rate',
  TenderAutoAcceptance: 'Tender Auto Acceptance',
  TenderWindowTime: 'Tender Window Time',
  BusinessWorkingDays: 'Business Working Days',
  BusinessWorkingHours: 'Business Working Hours',
  BusinessClosedDays: 'Business Closed Days',
  AdvancedTenderNotification: 'Advanced Tender Notification',
  KPIConfiguration: 'KPI Configuration',
  InvoiceMethod: 'Invoice Method',
  InvoicesPartyName: 'Invoices Party Name',
  InvoicesLocation: 'Invoices Location',
  ThirdPartyFreightPaymentCompany: 'Third Party Freight Payment Company',
  CreditLimit: 'Credit Limit',
  CreditDays: 'Credit Days',
  FinancialStabilityScore: 'Financial Stability Score',
  BillingDays: 'Billing Days',
  PaymentHistory: 'Payment History',
  MondayToFriday: 'Monday to Friday',
  Standard: 'Standard',
  SaturdayAndSunday: 'Saturday and Sunday',
  NoClosedDays: 'No Closed Days',
  TenderRejected: 'Tender Rejected',
  TenderAccepted: 'Tender accepted.',
  TenderCancelled: 'Tender cancelled.',
  TenderRejectedNotification: 'Tender rejected.',
  AddNewInsurance: 'Add New Insurance',
  AddNewLicense: 'Add New License',
  ShowInActiveInsurances: 'Show Inactive Insurances',
  ShowInActiveLicenses: 'Show Inactive Licenses',
  DocumentManagementSetting: 'Document Management Setting',
  DocumentUploadOperatingAuthorityInsuranceEtc:
    'Document Upload - Operating Authority, Insurance, Etc...',
  RulesTariff: 'Rules Tariff',
  AccessoriesList: 'Accessories List',
  OnTimeDeliveries: 'On Time Deliveries',
  EditInsurance: 'Edit Insurance',
  EditLicense: 'Edit License',
  CreateClaim: 'Create Claim',
  ClaimId: 'Claim Id',
  ClaimType: 'Claim Type',
  ShipmentId: 'Shipment Id',
  NPLCLaim: 'NPL Claim',
  ShipperOriginDetails: 'Shipper / Origin Details',
  ConsigneeDestinationDetails: 'Consignee / Destination Details',
  ClaimInTheAmountofUSD: 'Claim in the amount of (USD)',
  DateFiled: 'Date Filed',
  NPLTrack: 'NPL Track',
  ClaimantsClaim: 'Claimants Claim',
  BillofLading: 'Bill of Lading',
  ClaimisHereByFiledFor: 'Claim is hereby filled for',
  Shortage: 'Shortage',
  Overage: 'Overage',
  Damage: 'Damage',
  Other: 'Other',
  PickupDeliveryWindow: 'Pickup / Delivery Window',
  PickupReadyDate: 'Pickup Ready Date',
  ClosePickupDate: 'Close Pickup Date',
  DeliveryReadyDate: 'Delivery Ready Date',
  DeliveryCloseDate: 'Delivery Close Date',
  DetailedStatementShowingHowtheamountclaimedisDetermined:
    'Detailed Statement Showing How The Amount Claimed is Determined',
  TotalAmoutClaimed: 'Total Amount Claimed',
  ClaimValueBasedOn: 'Claim Value Based On',
  FullInvoiceValue: 'Full Invoice Value',
  Repair: 'Repair',
  Allowance: 'Allowance',
  TheForegoingStatementFactsisHerebycertifiedasCorrect:
    'The Foregoing Statement of facts is hereby certified as correct',
  ClaimantsRep: 'Claimants Rep',
  ClaimantsSignature: 'Claimants Signature',
  Date: 'Date',
  Fax: 'Fax',
  PTISales: 'PTI Sales',
  Consultant: 'Consultant',
  OriginalbillOfLading: 'Original Bill Of Lading',
  OriginalPaidFreightBill: 'Original Paid Freight Bill',
  CarriersInspectionReportForm: 'Carriers Inspection Report Form',
  PhotographsDocumentingDamage: 'Photographs Documenting Damage',
  OriginalInvoiceorCertifiedCopy: 'Original Invoice or Certified Copy',
  SignedCopyoftheDeliveryReceipt: 'Signed Copy of the Delivery Receipt',
  SearchByShipmentId: 'Search by Shipment ID',
  PleaseFillRequiredFields: 'Please Fill Required Fields',
  FailedToCreateEquipment: 'Failed To Create Equipment',
  EquipmentSavedSuccessfully: 'Equipment Saved Successfully',
  CounterofferedRate: 'Counteroffered Rate',
  ActionPendingLoads: 'Action Pending Loads',
  AcceptedLoads: 'Accepted Loads',
  DeclinedLoads: 'Declined Loads',
  AwardedLoads: 'Awarded Loads',
  CounterOfferedLoads: 'Counter Offered Loads',
  FailedToFetchLoadBoardDetails: 'Failed to fetch load board details',
  FailedToFetchQuoteDetails: 'Failed to fetch quote details',
  CounterOfferedLoadsCapped:
    'Only the {count} most recent submitted loads are checked for counter offers',
  Loading: 'Loading...',
  LiftGate: 'Lift Gate',
  CancelTender: 'Cancel Tender',
  PickedUp: 'Picked Up',
  Location: 'Location',
  LocationUpdate: 'Location Update',
  Remove: 'Remove',

  PickupRequirementsTitle: 'Pickup Requirements',
  NoCheckCallstoShow: 'No check calls to show',
  PreviousCheckCall: 'Previous Check Call',
  OrDropFileHere: 'Or drop file here',
  EnterProNumber: 'Enter PRO Number',
  UploadedDocument: 'Uploaded Document',
  EnterCabPowerNo: 'Enter Cab/Power No.',
  EnterTelephoneNo: 'Enter Telephone No.',
  EnterTrailerContainerNo: 'Enter Trailer/Container No.',
  TotalHUQuantity: 'Total HU Quantity',
  AddressDetails: 'Address Details',
  StopCheckCallDetails: 'Stop Check Call Details',
  ActualDepartureDateAndTime: 'Actual Departure Date & Time',
  DepartureDetails: 'Departure Details',
  ActualArrivalDateAndTime: 'Actual Arrival Date & Time',
  ArrivalDetails: 'Arrival Details',
  CarrierEmail: 'Carrier Email',
  CarrierContact: 'Carrier Contact',
  CarrierName: 'Carrier Name',
  NotAvailable: 'Not Available',
  LocationContact: 'Location Contact',
  ContactName: 'Contact Name',
  DocumentsReferences: 'Documents & References',
  BreakStart: 'Break Start',
  BreakEnd: 'Break End',
  ActualArrivalTime: 'Actual Arrival Time',
  ActualArrivalDate: 'Actual Arrival Date',
  Arrival: 'Arrival',
  Departure: 'Departure',
  EtaFinalDestinationOnTime: 'ETA Final Destination On Time',
  DateSlashTime: 'Date / Time',
  MostRecent: 'Most Recent',
  PickupShipments: 'Pickup Shipments',
  DeliveryShipments: 'Delivery Shipments',
  ScheduledArrivalDateAndTimeWindow: 'Scheduled Arrival Date & Time Window',
  ViewLess: 'View Less',
  ViewMore: 'View More',
  SelectPickupShipmentsOptional: 'Select Pickup Shipments (Optional)',
  SelectDeliveryShipmentsOptional: 'Select Delivery Shipments (Optional)',
  ReportException: 'Report Exception',
  SelectReferenceType: 'Select Reference Type',
  NeedUpdate: 'Need Update',
  CancelLoad: 'Cancel Load',
  ReasonForCancel: 'Reason for Cancel',
  Cancelledby: 'Cancelled by',
  CancellationNoficationWillBeSentToFollowingUsers:
    'Cancellation notification will be sent to following users',
  DontCancel: "Don't Cancel",
  CancelNotify: 'Cancel & Notify',
  Manual: 'Manual',
  Scan: 'Scan',
  ShowActiveEquipments: 'Show Active Equipments',
  ShowInActiveEquipments: 'Show Inactive Equipments',
  NoOfTransports: 'No of Transports',
  Amount: 'Amount',
  GeoFenceCreatedSuccessfully: 'Geo-fence created successfully',
  GeoFenceUpdatedSuccessfully: 'Geo-fence updated successfully',
  GeoFenceRemovedSuccessfully: 'Geo-fence removed successfully',
  FailedToRemoveGeoFence: 'Failed to remove geo-fence',
  FailedToUpdateGeoFence: 'Failed to update geo-fence',
  NoExistingGeoFencesToShow: 'No existing geo-fences to show',
  MapNotReadyToFocusFence: 'Map is still loading, please try again in a moment',
  CheckCallType: 'Check Call Type',
  DrawRectangle: 'Draw Rectangle',
  DrawCircle: 'Draw Circle',
  DrawPolygon: 'Draw Polygon',
  PanMap: 'Pan / Move',
  BOLPreview: 'BOL Preview',
  TransportUpdateSuccessMessage: 'Transport details updated successfully',
  ContractUpdateSuccessMessage: 'Contract details updated successfully',
  ZipCode: 'Zip Code',
  AllRouteStops: 'All Route Stops',

  FreezeUpdates: 'Freeze Updates',
  DocumentsRequiredAtTheStop: 'Documents Required at the Stop',
  EnterPRONo: 'Enter PRO No.',
  TotalHUWeight: 'Total HU Weight',
  TotalHUQty: 'Total HU Qty',
  InTransitCheckCall: 'In-Transit Check Call',
  ActualHUQuantity: 'Actual HU Quantity',
  ActualHUWeight: 'Actual HU Weight',
  Document: 'Document',
  NoDataAttachedYet: 'No Data Attached Yet',
  OrDragAndDrop: 'Or Drag and Drop',
  ExcelDocPdfJpeg: 'Excel, Doc, Pdf, Jpeg',
  ClickToUpload: 'Click to Upload',
  DrawSignatureWithMouseOrTouch: 'Draw Signature with Mouse or Touch',
  NoSignatureCaptured: 'No Signature Captured',
  NoDocumentUploaded: 'No Document Uploaded',
  PodRequiredShipments: 'POD Required Shipments',
  PodSubmittedShipments: 'POD Submitted Shipments',
  DefaultUserName: 'Default User Name',
  UserName: 'User Name',
  ApprovalWorkflow: 'Approval Workflow',
  FromDate: 'From Date',
  ToDate: 'To Date',
  Delegatee: 'Delegatee',
  WorkingInfo: 'Working Info',
  WorkingDays: 'Working Days',
  WorkingDaysRange: 'Monday - Friday',
  Hours: 'Hours',
  WorkingHoursRange: '09:30 AM - 18:30 PM',
  ReportingTo: 'Reporting To',
  WorkflowDelegation: 'Workflow Delegation',
  DoNotSendAutomaticReplies: 'Do not send automatic replies',
  SendAutomaticReplies: 'Send automatic replies',
  OnlySendDuringThisTimeRange: 'Only send during this time range',
  AutomaticReplyMessageInstruction:
    'Automatically reply once per each sender with the following messages',
  FailedToLoadServiceLevelDetails: 'Failed to load service level details',
  FailedToLoadEquipmentTypeDetails: 'Failed to load equipment type details',
  FailedToFetchContactDetails: 'Failed to fetch contact details',
  FailedToFetchContactDetailsNetworkError:
    'Failed to fetch contact details due to a network error',
  FailedToFetchCostInvoicesNetworkError:
    'Failed to fetch cost invoices due to a network error',
  FailedToFetchCurrencyDetailsNetworkError:
    'Failed to fetch currency details due to a network error',
  FailedToFetchEquipmentTypeDetailsNetworkError:
    'Failed to fetch equipment type details due to a network error',
  FailedToFetchHandlingUnitTypeDetails:
    'Failed to fetch handling unit type details',
  FailedToFetchHandlingUnitTypeDetailsNetworkError:
    'Failed to fetch handling unit type details due to a network error',
  FailedToFetchOrderDetailsNetworkError:
    'Failed to fetch order details due to a network error',
  FailedToFetchReferenceTypeDetailsNetworkError:
    'Failed to fetch reference type details due to a network error',
  FailedToFetchServiceLevelDetailsNetworkError:
    'Failed to fetch service level details due to a network error',
  FailedToFetchShipmentTypeDetailsNetworkError:
    'Failed to fetch shipment type details due to a network error',
  FailedToFetchTransportationModeDetailsNetworkError:
    'Failed to fetch transportation mode details due to a network error'
};
export default en;
